var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 15.1422,
    cy: 16,
    rx: 15.1422,
    ry: 16,
    fill: "#8A8D9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.875L12.4563 19.3646C12.6114 19.5962 12.8687 19.7386 13.1473 19.7469C13.4259 19.7552 13.6913 19.6284 13.8599 19.4065L21.125 12",
    fill: "#8A8D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.875L12.4563 19.3646C12.6114 19.5962 12.8687 19.7386 13.1473 19.7469C13.4259 19.7552 13.6913 19.6284 13.8599 19.4065L21.125 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconGrey);
export default __webpack_public_path__ + "static/media/tick-icon-grey.bd566ac7e87301dfacea1cb86539c807.svg";
export { ForwardRef as ReactComponent };